module.exports = "/_next/static/resources/life1-ca967d7defd03cf4c8d5171133e16b52.webp";